import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { Backdrop, CircularProgress } from "@mui/material";

const Cancel = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);

  useEffect(() => {
    document.title = "Cancel | Kloudscan";
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setOpen(false);
      navigate("/checkout");
    }, 1000); // Adjust delay if needed

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Backdrop
      sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
      open={open}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default Cancel;
